import styles from './newsCard.module.css';
import { useNavigate } from "react-router-dom";

function NewsCard({ data }) {
    const navigate = useNavigate();
    const highlighted = data.is_highlighted === 1 ? true : false;
    if (!data) return null; // Prevent rendering errors if data is undefined

    const maxLenghtTitle = 45;
    const title = (data.title.length > maxLenghtTitle) ? data.title.slice(0, maxLenghtTitle) + "..." : data.title;

    return (
        <div tabIndex={0} className={styles.cardContainer} onClick={() => navigate(`/news/${data.slug}`)}
            onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault(); // Prevent space from scrolling
                    navigate(`/news/${data.slug}`)
                }
            }}
        >
            <div className={styles.imgContainer}>
                <img
                    className={styles.image}
                    src={`${process.env.PUBLIC_URL}${data.image}`}
                    alt={data.title}
                />
            </div>
            <div className={styles.titleContainer}>
                <p className={styles.title}>{title}</p>
            </div>
            {highlighted && (
                <img className={styles.stern} src={`/assets/icons/star-icon.svg`}
                    alt="Stern" />
            )}
            <p className={styles.date}>{data.published_date}</p>
        </div>
    );
}

export default NewsCard;
